import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { EventsListPage } from './events-list.page';
import { EventsListDesktopPage } from './desktop/events.list.desktop.page';
import { EventsListMobilePage } from './mobile/events-list.mobile.page';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslationModule } from '@app/app-translation.module';
import { PipesModule } from '@shared-pipes/pipes.module';
import { DirectivesModule } from '@shared-directives/directives.module';
import { IonicModule } from '@ionic/angular';
import { MobileHeaderComponentModule } from '@internal/gui/structural-components/mobile-header-component/mobile-header-component.module';
import { TableMobileModule } from '@beego/ngx-table';
import { AppModule } from '@app/app.module';
import { StateManager } from '@shared-managers/state.manager';
import { TranslateService } from '@ngx-translate/core';
import { InputFilterModule } from '@beego/ngx-input-filter';
import { SelectFilterModule } from '@beego/ngx-select-filter';

@NgModule({
	imports: [
		CommonModule,
		RouterModule.forChild([
			{
				path: '',
				component: EventsListPage,
			},
		]),
		TranslationModule,
		PipesModule,
		DirectivesModule,
		IonicModule,
		InputFilterModule,
		SelectFilterModule,
		MobileHeaderComponentModule,
		TableMobileModule.forRoot(AppModule.injector.get(StateManager), AppModule.injector.get(TranslateService)),
	],
	declarations: [EventsListPage, EventsListDesktopPage, EventsListMobilePage],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EventsListPageModule {}
